<script>
  import { onMount } from 'svelte';
  export let source = "";
  let code = "";

  onMount(() => {
    fetch(source) 
      .then(resource => resource.text())
      .then(data => code = data);
  });
</script>


<style>

</style>


<pre>
<code>
{code}
</code>
</pre>

